import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import PackageSelect from 'ApplicationEntry/components/WorkFlow/ProductsRiders/PackageSelect';
import {CaseDetails, matchCaseDetailsByType} from 'ApplicationEntry/models/CaseDetails';
import {
  InvalidGroupUL,
  ValidGroupUL,
  isSpouse,
  planList,
} from 'ApplicationEntry/models/ProductsRiders/UniversalLife/GroupUL';
import States from 'ApplicationEntry/models/States';
import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import * as ErrorMessages from '../../ErrorMessages';
import './../ProductRiders.sass';
import * as BAActions from 'ApplicationEntry/ducks/billingAgent';
import * as ULActions from 'ApplicationEntry/ducks/ProductsRiders/universalLife';
import FixedCodeRiderInformation from '../FixedCodeRiderInformation';
import {ValidGroupCaseDetails} from 'ApplicationEntry/models/GroupCaseDetails';
import {getSitusStatefromCaseNumber} from 'ApplicationEntry/ducks/caseDetails';

type ULProps = {
  universalLife: InvalidGroupUL | ValidGroupUL;
  caseDetails: CaseDetails;
};

const UniversalLife = ({universalLife, caseDetails}: ULProps) => {
  const dispatch = useDispatch();
  const {
    plan,
    cwa,
    calculatedPremium,
    type,
    faceAmt,
    premiumType,
    priInsured,
    spouseInsured,
    replacement,
    riderInformation,
    commission,
    deathBenefit,
    adb,
    chronicIllness,
    guac,
    sbVolume,
    waiver,
    packageName,
    packageList,
    gulbr,
    gultc,
    gultcext,
  } = universalLife;
  const [planBlurred, setBlurPlan] = useState(false);
  const [typeLabel, setTypeLabel] = useState<HTMLLabelElement | null>();
  const [situsLabel, setSitusLabel] = useState<HTMLLabelElement | null>();
  const [insuredLabel, setInsuredLabel] = useState<HTMLLabelElement | null>();
  const showPlanError = planBlurred && plan.key === 'Empty';
  let {situsState} = caseDetails as ValidGroupCaseDetails;

  const getADBVolume = (event: React.ChangeEvent<HTMLInputElement>) => {
    let selectedPackage: object = {};
    if (packageList.key === 'Loaded') {
      selectedPackage = packageList.Data.filter(
        (packageItem: object) => packageItem['packageName'] === packageName.value
      );
    }
    const guacI50: string = selectedPackage[0]['guaci50'];
    const guacI100: string = selectedPackage[0]['guaci100'];

    let guactext: string = '';
    switch (guacI50) {
      case '0':
      case '1':
        guactext = '50';
    }
    switch (guacI100) {
      case '0':
      case '1':
        guactext = '100';
    }
    dispatch(ULActions.changeChronicIllness(guactext));
    dispatch(ULActions.changeRiderInformation(event.target.checked ? Number(guactext) : Number.NaN, 'GUACI', 7));
  };

  return (
    <div className="product-riders-section__policy-type" id="ul-section">
      <form noValidate autoComplete="off" className="product-riders-section__policy-type__form">
        <div className="product-riders-section__policy-type__form__row">
          <Grid container spacing={4}>
            <Grid item xs={12} md={3}>
              <FormControl
                error={showPlanError}
                variant="outlined"
                className="product-riders-section__policy-type__form__row--field"
              >
                <InputLabel
                  ref={setTypeLabel}
                  id="ul-plan-label"
                  className={'product-riders-section__policy-type__form__row--label'}
                >
                  Plan
                </InputLabel>
                <Select
                  labelId="ul-label-plan"
                  labelWidth={typeLabel?.clientWidth}
                  id="ul-plan"
                  value={plan.key === 'Empty' ? '' : plan.value}
                  onBlur={() => setBlurPlan(true)}
                  onChange={e => {
                    const caseNum = matchCaseDetailsByType({
                      Group: groupApp => (groupApp.caseNumber.key === 'Loaded' ? groupApp.caseNumber.Data : ''),
                      _: () => '',
                    })(caseDetails);
                    dispatch(ULActions.getPackageList(caseNum, e.target.value as string));
                    dispatch(ULActions.changePlan(e.target.value as string));
                  }}
                  displayEmpty
                >
                  {planList.map((product: {name: string; displayName: string}, index: number) => (
                    <MenuItem value={product.name} key={`ul-product-${product.name}-${index}`}>
                      {product.displayName}
                    </MenuItem>
                  ))}
                </Select>
                {showPlanError && <FormHelperText>{ErrorMessages.REQUIRED_MESSAGE}</FormHelperText>}
              </FormControl>
            </Grid>
            {plan.key === 'NonEmpty' ? (
              <>
                <Grid item xs={12} md={3}>
                  <FormControl variant="outlined" className="product-riders-section__policy-type__form__row--field">
                    <InputLabel
                      ref={setTypeLabel}
                      id="ul-type-label"
                      className={'product-riders-section__policy-type__form__row--label'}
                    >
                      Type
                    </InputLabel>
                    <Select
                      labelId="ul-label-type"
                      labelWidth={typeLabel?.clientWidth}
                      id="ul-type"
                      value={type.key === 'Empty' ? '' : type.value}
                      onChange={e => {
                        dispatch(ULActions.changeType(e.target.value as string));
                        if (isSpouse(e.target.value as string)) {
                          dispatch(ULActions.resetSpouseInsured());
                        }
                      }}
                      displayEmpty
                    >
                      <MenuItem value="Employee">Employee</MenuItem>
                      <MenuItem value="Spouse">Spouse</MenuItem>
                      <MenuItem value="Child">Child</MenuItem>
                      <MenuItem value="Other">Other</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={3}>
                  <FormControl variant="outlined" className="product-riders-section__policy-type__form__row--field">
                    <InputLabel
                      ref={setSitusLabel}
                      id="ul-situs-label"
                      className={'product-riders-section__policy-type__form__row--label'}
                    >
                      Situs State
                    </InputLabel>
                    <Select
                      labelId="ul-label-situs"
                      labelWidth={situsLabel?.clientWidth}
                      id="ul-situs"
                      value={situsState.value || universalLife.situsState.value}
                      onChange={e => {
                        dispatch(ULActions.changeSitusState(e.target.value as string));
                        dispatch(getSitusStatefromCaseNumber(''));
                      }}
                      displayEmpty
                    >
                      {States.map(stateCode => (
                        <MenuItem key={stateCode} value={stateCode}>
                          {stateCode}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    id="ul-faceAmt"
                    label="Face Amount"
                    variant="outlined"
                    placeholder="Face Amount"
                    type="number"
                    margin="normal"
                    fullWidth
                    className="product-riders-section__policy-type__form__row--field"
                    value={faceAmt.key === 'Empty' ? '' : faceAmt.value}
                    onChange={e => dispatch(ULActions.changeFaceAmt(e.target.value as string))}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <FormControl variant="outlined" className="product-riders-section__policy-type__form__row--field">
                    <InputLabel
                      ref={setInsuredLabel}
                      id="ul-primary-label"
                      className={'product-riders-section__policy-type__form__row--label'}
                    >
                      Primary Insured
                    </InputLabel>
                    <Select
                      labelId="ul-label-primary"
                      labelWidth={insuredLabel?.clientWidth}
                      id="ul-primary"
                      value={priInsured.key === 'Empty' ? '' : priInsured.value}
                      onChange={e => dispatch(ULActions.changePriInsured(e.target.value as string))}
                      displayEmpty
                    >
                      <MenuItem value="">&nbsp;&nbsp;</MenuItem>
                      <MenuItem value="Smoker">Smoker</MenuItem>
                      <MenuItem value="Non Smoker">Non Smoker</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={3}>
                  <FormControl variant="outlined" className="product-riders-section__policy-type__form__row--field">
                    <InputLabel
                      ref={setTypeLabel}
                      id="ul-spouse-label"
                      className={'product-riders-section__policy-type__form__row--label'}
                    >
                      Spouse
                    </InputLabel>
                    <Select
                      labelId="ul-label-spouse"
                      labelWidth={typeLabel?.clientWidth}
                      id="ul-spouse"
                      value={spouseInsured.key === 'Empty' ? '' : spouseInsured.value}
                      onChange={e => dispatch(ULActions.changeSpouseInsured(e.target.value as string))}
                      displayEmpty
                      disabled={isSpouse(type.value)}
                    >
                      <MenuItem value="">&nbsp;&nbsp;</MenuItem>
                      <MenuItem value="Smoker">Smoker</MenuItem>
                      <MenuItem value="Non Smoker">Non Smoker</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={3}>
                  <FormControl component="fieldset" className="product-riders-section__policy-type__form__row--field">
                    <RadioGroup
                      aria-label="Premium Type"
                      name="ul-premium-type-group"
                      value={premiumType.value}
                      onChange={e => dispatch(ULActions.changePremiumType(e.target.value as string))}
                    >
                      <FormControlLabel
                        key="Modal"
                        value="Modal"
                        control={<Radio />}
                        label="Modal"
                        className="ul-section__form-radio-button"
                      />
                      <FormControlLabel
                        key="Annual"
                        value="Annual"
                        control={<Radio />}
                        label="Annual"
                        className="ul-section__form-radio-button"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    id="ul-premium"
                    label="Premium"
                    variant="outlined"
                    placeholder="Premium"
                    margin="normal"
                    fullWidth
                    className="product-riders-section__policy-type__form__row--field"
                    value={calculatedPremium.key === 'Empty' ? '' : calculatedPremium.value}
                    onChange={event => {
                      dispatch(ULActions.changePremium(event.target.value as string));
                      dispatch(ULActions.changeCalculatedPremium(event.target.value as string));
                    }}
                    disabled={premiumType.key === 'Empty'}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <TextField
                    id="ul-cwa"
                    label="CWA"
                    variant="outlined"
                    placeholder="CWA"
                    margin="normal"
                    fullWidth
                    className="product-riders-section__policy-type__form__row--field"
                    value={cwa.key === 'Empty' ? '' : cwa.value}
                    onChange={e => dispatch(ULActions.changeCWA(e.target.value as string))}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="secondary"
                        checked={replacement}
                        name="checkedB"
                        onChange={() => dispatch(ULActions.changeReplacement(!replacement))}
                      />
                    }
                    label={<Typography>Replacement</Typography>}
                    className="product-riders-section__policy-type__form__row--field"
                  />
                  <FormControl
                    component="fieldset"
                    className="product-riders-section__policy-type__form__row--field"
                    disabled={!replacement}
                  >
                    <RadioGroup
                      aria-label="Commission"
                      name="ul-label-commission"
                      value={commission.value}
                      onChange={e => dispatch(ULActions.changeCommission(e.target.value as string))}
                    >
                      <FormControlLabel
                        key="First Year Commissions"
                        value="First Year Commissions"
                        control={<Radio />}
                        label="First Year Commissions"
                        className="ul-section__form-radio-button"
                      />
                      <FormControlLabel
                        key="Renewal Commissions"
                        value="Renewal Commissions"
                        control={<Radio />}
                        label="Renewal Commissions"
                        className="ul-section__form-radio-button"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </>
            ) : (
              <></>
            )}
          </Grid>
          {plan.key === 'NonEmpty' ? (
            <>
              <Grid item xs={12}>
                <Typography variant="subtitle1" className="product-riders-section__sub-title">
                  Riders
                </Typography>
              </Grid>
              <div className="product-riders-section__policy-type__form__row">
                <Grid container spacing={4}>
                  <Grid item xs={12} md={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="secondary"
                          checked={waiver}
                          name="checkedB"
                          onChange={event => {
                            dispatch(ULActions.changeWaiver(!waiver));
                            dispatch(
                              ULActions.changeRiderInformation(event.target.checked ? 1 : Number.NaN, 'GUPWP', 8)
                            );
                          }}
                        />
                      }
                      label={<Typography>Waiver</Typography>}
                      className="product-riders-section__policy-type__form__row--field"
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="secondary"
                          checked={gulbr}
                          onChange={event => {
                            dispatch(ULActions.changeGULBR(!gulbr));
                            dispatch(
                              ULActions.changeRiderInformation(event.target.checked ? 1 : Number.NaN, 'GULBR', 0)
                            );
                          }}
                          name="checkedB"
                        />
                      }
                      label={<Typography>GULBR</Typography>}
                      className="product-riders-section__policy-type__form__row--field"
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="secondary"
                          checked={guac}
                          onChange={event => {
                            dispatch(ULActions.changeGUAC(!guac));
                            getADBVolume(event);
                            if (!event.target.checked) {
                              dispatch(ULActions.changeChronicIllness(''));
                            }
                          }}
                          name="checkedB"
                        />
                      }
                      label={<Typography>GUAC</Typography>}
                      className="product-riders-section__policy-type__form__row--field"
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      id="ul-illness"
                      label="ADB Chronic Illness"
                      variant="outlined"
                      placeholder="ADB Chronic Illness"
                      margin="normal"
                      fullWidth
                      className="product-riders-section__policy-type__form__row--field"
                      value={chronicIllness.key === 'Empty' ? '' : chronicIllness.value}
                      onChange={event => dispatch(ULActions.changeChronicIllness(event.target.value as string))}
                      disabled
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="secondary"
                          checked={gultc}
                          onChange={event => {
                            dispatch(ULActions.changeGULTC(!gultc));
                            dispatch(
                              ULActions.changeRiderInformation(event.target.checked ? 1 : Number.NaN, 'GULTC', 4)
                            );
                          }}
                          name="checkedB"
                        />
                      }
                      label={<Typography>GULTC</Typography>}
                      className="product-riders-section__policy-type__form__row--field"
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="secondary"
                          checked={gultcext}
                          onChange={event => {
                            dispatch(ULActions.changeGULTCEXT(!gultcext));
                            dispatch(
                              ULActions.changeRiderInformation(
                                event.target.checked ? 1 : Number.NaN,
                                'GULTCEXT+GULTC',
                                5
                              )
                            );
                          }}
                          name="checkedB"
                        />
                      }
                      label={<Typography>GULTC + GULTCEXT</Typography>}
                      className="product-riders-section__policy-type__form__row--field"
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="secondary"
                          checked={adb}
                          name="checkedB"
                          onChange={event => {
                            dispatch(ULActions.changeADB(!adb));
                            dispatch(
                              ULActions.changeRiderInformation(event.target.checked ? 0 : Number.NaN, 'GUADB', 6)
                            );
                          }}
                        />
                      }
                      label={<Typography>ADB</Typography>}
                      className="product-riders-section__policy-type__form__row--field"
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      id="ul-sb"
                      label="Volume"
                      variant="outlined"
                      placeholder="Volume"
                      margin="normal"
                      type="number"
                      fullWidth
                      className="product-riders-section__policy-type__form__row--field"
                      value={sbVolume.key === 'Empty' ? '' : sbVolume.value}
                      onChange={e => {
                        dispatch(ULActions.changeSBVolume(e.target.value as string));
                        dispatch(ULActions.changeRiderInformation(Number(e.target.value as string), 'GUADB', 6));
                      }}
                      disabled={!adb}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormLabel id="ul-death-benefit">Death Benefit</FormLabel>
                    <FormControl component="fieldset" className="product-riders-section__policy-type__form__row--field">
                      <RadioGroup
                        aria-label="Death Benefit"
                        name="ul-death-benefit-group"
                        value={deathBenefit.value}
                        onChange={e => dispatch(ULActions.changeDeathBenefit(e.target.value as string))}
                      >
                        <FormControlLabel
                          key="Option 1"
                          value="Option 1"
                          control={<Radio />}
                          label="Option 1"
                          className="ul-section__form-radio-button"
                        />
                        <FormControlLabel
                          key="Option 2"
                          value="Option 2"
                          control={<Radio />}
                          label="Option 2"
                          className="ul-section__form-radio-button"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <PackageSelect
                      packageName={packageName}
                      packageList={packageList}
                      hidden={true}
                      changePackageAction={ULActions.changePackageName}
                      handlePackageItems={(packageItem: object) => dispatch(ULActions.changePackageItem(packageItem))}
                    />
                  </Grid>
                </Grid>
              </div>
            </>
          ) : (
            <></>
          )}
          {plan.key === 'NonEmpty' ? (
            <FixedCodeRiderInformation
              riderInformation={riderInformation}
              changeRiderInformationAction={ULActions.changeRiderInformation}
              identifier={'group-ul'}
              disableTitle
            />
          ) : (
            <></>
          )}
        </div>
      </form>
    </div>
  );
};

export default UniversalLife;
